<!--
    *ngIf="true" is required for router-outlet to work properly.
    Else, it won't register the changes on the layout and won't update the view.
 -->
<router-outlet *ngIf="true"></router-outlet>
